"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openEditSitemapPageOptionsModal = exports.openAddPageToSitemapModal = exports.openUpdatePageUrlModal = exports.openRedirectToAffectedPagesModal = exports.openEditDomainLanguageModal = exports.ModalActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var ModalActionTypes = (0, _namespacedKeyMirror.default)({
  CLOSE_MODAL: null,
  OPEN_EDIT_DOMAIN_LANGUAGE_MODAL: null,
  OPEN_REDIRECT_TO_AFFECTED_PAGES_MODAL: null,
  OPEN_UPDATE_PAGE_URL_MODAL: null,
  OPEN_ADD_PAGE_TO_SITEMAP_MODAL: null,
  OPEN_EDIT_SITEMAP_PAGE_OPTIONS_MODAL: null
}, _UrlPathParams.DOMAINS);
exports.ModalActionTypes = ModalActionTypes;
var openEditDomainLanguageModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_EDIT_DOMAIN_LANGUAGE_MODAL);
exports.openEditDomainLanguageModal = openEditDomainLanguageModal;
var openRedirectToAffectedPagesModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_REDIRECT_TO_AFFECTED_PAGES_MODAL);
exports.openRedirectToAffectedPagesModal = openRedirectToAffectedPagesModal;
var openUpdatePageUrlModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_UPDATE_PAGE_URL_MODAL);
exports.openUpdatePageUrlModal = openUpdatePageUrlModal;
var openAddPageToSitemapModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_ADD_PAGE_TO_SITEMAP_MODAL);
exports.openAddPageToSitemapModal = openAddPageToSitemapModal;
var openEditSitemapPageOptionsModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_EDIT_SITEMAP_PAGE_OPTIONS_MODAL);
exports.openEditSitemapPageOptionsModal = openEditSitemapPageOptionsModal;
var closeModal = (0, _fluxActions.createAction)(ModalActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;